import {ChangeDetectionStrategy, Component, computed, inject, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {TemplateService} from 'src/app/services/AIReports/template.service';
import {DialogBaseComponent} from 'src/app/components/common/dialog/dialog-base/dialog-base.component';
import {AiChatFacade} from "@components/mainmenu/reports-menu/ai-reports/ai-reports-sub-menu/chat/ai-chat.facade";

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrl: './templates.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplatesComponent extends DialogBaseComponent {

  private readonly templateService = inject(TemplateService);
  private readonly facade = inject(AiChatFacade);

  readonly templateSelected = output<string | null>();

  readonly prompts = toSignal(this.templateService.listSummaries(), {
    initialValue: [],
  });

  readonly hasPrompts = computed(() => this.prompts().length > 0);

  readonly cards = computed(() =>
    this.prompts().map((p: any) => ({
      id: p.id,
      title: p.label,
      desc: p.description,
      image: p.previewUrl,
    }))
  );

  async onCardClick(templateId: string) {
    try {
      const prompt = await this.templateService.loadPrompt(templateId);
      this.templateSelected.emit(prompt);
    } catch (err) {
      throw new Error('TemplatesComponent: Failed to load template prompt');
    }
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  async cancel() {
    await this.facade.newThread();
    this.close();
  }
}
